// Tutorial step definitions by role and center type
export const TUTORIAL_VERSION = '1.0.0';

// Tutorial steps for different roles and center types
export const TUTORIAL_STEPS = {
  admin: {
    learning: [
      {
        target: 'body',
        content: 'tutorial.welcome.description',
        placement: 'center',
        disableBeacon: true,
        locale: { skip: 'tutorial.navigation.skip', next: 'tutorial.welcome.start' }
      },
      {
        target: '[data-tour="dashboard-stats"]',
        content: 'tutorial.admin.dashboard.stats',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        target: '[data-tour="dashboard-search"]',
        content: 'tutorial.admin.dashboard.search',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        target: '[data-tour="students-nav"]',
        content: 'tutorial.admin.nav.students',
        placement: 'right',
        disableBeacon: true
      },
      {
        target: '[data-tour="teachers-nav"]',
        content: 'tutorial.admin.nav.teachers',
        placement: 'right',
        disableBeacon: true
      },
      {
        target: '[data-tour="groups-nav"]',
        content: 'tutorial.admin.nav.groups',
        placement: 'right',
        disableBeacon: true
      },
      {
        target: '[data-tour="jibaya-nav"]',
        content: 'tutorial.admin.nav.jibaya',
        placement: 'right',
        disableBeacon: true
      },
      {
        target: '[data-tour="settings-nav"]',
        content: 'tutorial.admin.nav.settings',
        placement: 'right',
        disableBeacon: true,
        locale: { last: 'tutorial.navigation.last' }
      }
    ],
    therapy: [
      {
        target: 'body',
        content: 'tutorial.welcome.description',
        placement: 'center',
        disableBeacon: true,
        locale: { skip: 'tutorial.navigation.skip', next: 'tutorial.welcome.start' }
      },
      {
        target: '[data-tour="dashboard-stats"]',
        content: 'tutorial.therapy.dashboard.stats',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        target: '[data-tour="students-nav"]',
        content: 'tutorial.therapy.nav.clients',
        placement: 'right',
        disableBeacon: true
      },
      {
        target: '[data-tour="settings-nav"]',
        content: 'tutorial.admin.nav.settings',
        placement: 'right',
        disableBeacon: true,
        locale: { last: 'tutorial.navigation.last' }
      }
    ]
  },
  center_manager: {
    learning: [
      {
        target: 'body',
        content: 'tutorial.welcome.description',
        placement: 'center',
        disableBeacon: true,
        locale: { skip: 'tutorial.navigation.skip', next: 'tutorial.welcome.start' }
      },
      {
        target: '[data-tour="dashboard-stats"]',
        content: 'tutorial.admin.dashboard.stats',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        target: '[data-tour="dashboard-search"]',
        content: 'tutorial.admin.dashboard.search',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        target: '[data-tour="students-nav"]',
        content: 'tutorial.admin.nav.students',
        placement: 'right',
        disableBeacon: true
      },
      {
        target: '[data-tour="teachers-nav"]',
        content: 'tutorial.admin.nav.teachers',
        placement: 'right',
        disableBeacon: true
      },
      {
        target: '[data-tour="groups-nav"]',
        content: 'tutorial.admin.nav.groups',
        placement: 'right',
        disableBeacon: true
      },
      {
        target: '[data-tour="jibaya-nav"]',
        content: 'tutorial.admin.nav.jibaya',
        placement: 'right',
        disableBeacon: true
      },
      {
        target: '[data-tour="settings-nav"]',
        content: 'tutorial.admin.nav.settings',
        placement: 'right',
        disableBeacon: true,
        locale: { last: 'tutorial.navigation.last' }
      }
    ],
    therapy: [
      {
        target: 'body',
        content: 'tutorial.welcome.description',
        placement: 'center',
        disableBeacon: true,
        locale: { skip: 'tutorial.navigation.skip', next: 'tutorial.welcome.start' }
      },
      {
        target: '[data-tour="dashboard-stats"]',
        content: 'tutorial.therapy.dashboard.stats',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        target: '[data-tour="students-nav"]',
        content: 'tutorial.therapy.nav.clients',
        placement: 'right',
        disableBeacon: true
      },
      {
        target: '[data-tour="settings-nav"]',
        content: 'tutorial.admin.nav.settings',
        placement: 'right',
        disableBeacon: true,
        locale: { last: 'tutorial.navigation.last' }
      }
    ]
  },
  teacher: {
    learning: [
      {
        target: 'body',
        content: 'tutorial.teacher.welcome',
        placement: 'center',
        disableBeacon: true,
        locale: { skip: 'tutorial.navigation.skip', next: 'tutorial.welcome.start' }
      },
      {
        target: '[data-tour="teacher-groups"]',
        content: 'tutorial.teacher.groups.overview',
        placement: 'bottom',
        disableBeacon: true
      },
      {
        target: '[data-tour="teacher-group-card"]',
        content: 'tutorial.teacher.groups.card',
        placement: 'top',
        disableBeacon: true
      },
      {
        target: '[data-tour="teacher-attendance-btn"]',
        content: 'tutorial.teacher.groups.attendance',
        placement: 'top',
        disableBeacon: true
      },
      {
        target: '[data-tour="teacher-checklists-btn"]',
        content: 'tutorial.teacher.groups.checklists',
        placement: 'top',
        disableBeacon: true,
        locale: { last: 'tutorial.navigation.last' }
      }
    ],
    therapy: [
      {
        target: 'body',
        content: 'tutorial.teacher.welcome',
        placement: 'center',
        disableBeacon: true,
        locale: { skip: 'tutorial.navigation.skip', next: 'tutorial.welcome.start' }
      },
      {
        target: '[data-tour="teacher-groups"]',
        content: 'tutorial.teacher.groups.overview',
        placement: 'bottom',
        disableBeacon: true,
        locale: { last: 'tutorial.navigation.last' }
      }
    ]
  },
  super_admin: {
    learning: [
      {
        target: 'body',
        content: 'tutorial.welcome.description',
        placement: 'center',
        disableBeacon: true,
        locale: { skip: 'tutorial.navigation.skip', next: 'tutorial.welcome.start' }
      },
      {
        target: '[data-tour="dashboard-stats"]',
        content: 'tutorial.admin.dashboard.stats',
        placement: 'bottom',
        disableBeacon: true,
        locale: { last: 'tutorial.navigation.last' }
      }
    ],
    therapy: [
      {
        target: 'body',
        content: 'tutorial.welcome.description',
        placement: 'center',
        disableBeacon: true,
        locale: { skip: 'tutorial.navigation.skip', next: 'tutorial.welcome.start' }
      },
      {
        target: '[data-tour="dashboard-stats"]',
        content: 'tutorial.therapy.dashboard.stats',
        placement: 'bottom',
        disableBeacon: true,
        locale: { last: 'tutorial.navigation.last' }
      }
    ]
  }
};

// Tutorial configuration for react-joyride
export const TUTORIAL_CONFIG = {
  continuous: true,
  showProgress: true,
  showSkipButton: true,
  disableOverlay: false,
  disableCloseOnEsc: false,
  spotlightClicks: false,
  styles: {
    options: {
      primaryColor: '#10b981',
      zIndex: 10000,
      arrowColor: '#fff',
      backgroundColor: 'var(--color-surface)',
      overlayColor: 'rgba(0, 0, 0, 0.5)',
      textColor: 'var(--color-text-primary, #1f2937)',
      width: 400,
    },
    tooltip: {
      borderRadius: '12px',
      fontSize: '15px',
      padding: '20px'
    },
    tooltipContainer: {
      textAlign: 'left'
    },
    buttonNext: {
      backgroundColor: '#10b981',
      borderRadius: '8px',
      padding: '10px 20px',
      fontSize: '14px',
      fontWeight: '600'
    },
    buttonBack: {
      color: 'var(--color-text-secondary, #6b7280)',
      marginRight: '10px',
      fontSize: '14px'
    },
    buttonSkip: {
      color: 'var(--color-text-tertiary, #9ca3af)',
      fontSize: '14px'
    }
  }
};

// Helper function to get tutorial steps for a specific role and center type
export const getTutorialSteps = (role, centerType = 'learning') => {
  // Default to admin role if role not found
  const normalizedRole = role?.toLowerCase() || 'admin';
  let normalizedCenterType = centerType?.toLowerCase() || 'learning';

  // Hair transplant centers reuse therapy tutorial steps
  if (normalizedCenterType === 'hair_transplant') {
    normalizedCenterType = 'therapy';
  }

  return TUTORIAL_STEPS[normalizedRole]?.[normalizedCenterType] ||
         TUTORIAL_STEPS.admin.learning;
};

// Helper function to get RTL-adjusted configuration
export const getTutorialConfig = (isRTL = false) => {
  const config = { ...TUTORIAL_CONFIG };

  if (isRTL) {
    config.styles = {
      ...config.styles,
      tooltipContainer: {
        textAlign: 'right',
        direction: 'rtl'
      }
    };
  }

  return config;
};
